import React, { FC, ReactNode } from 'react';
import './nav.sass';
import { INavSearchProps } from '../nav-search/nav-search';
import { INavListProps } from '../nav-list/nav-list';
import { IAddPostButtonProps } from '../themes/common/add-post/add-post-button';
import { Nullable } from '../../../../shared/types/Typescript-utils';
import { IQueryParamFilters } from '../../../../shared/services/api.service';
import { ISocialFeedsGroupedItem, SocialFeedsTypesMap } from '../../../../shared/mappers/map-social-feeds';
import NavTagsList from '../nav-tags-list/nav-tags-list';

export interface INavConfig {
  bannerHeight?: number;
  publicPost: boolean;
  waterfallToggle?: Nullable<boolean>;
  handleOnNavItemClick: (payload: IQueryParamFilters) => void;
  navItemColor: string;
  handleOnNavSearch: (payload: IQueryParamFilters) => void;
  navSearchColor: string;
  tags?: string;
}

interface INavProps {
  navConfig: INavConfig;
  addPostConfig: IAddPostButtonProps;
  socialFeeds: SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]>;
  renderAddPost?: (props: IAddPostButtonProps) => ReactNode;
  renderNavSearch?: (props: INavSearchProps) => ReactNode;
  renderNavList?: (props: INavListProps) => ReactNode;
}

const Nav: FC<INavProps> = ({
  navConfig,
  addPostConfig,
  socialFeeds,
  renderAddPost,
  renderNavSearch,
  renderNavList,
}) => {
  const { handleOnNavItemClick, navItemColor, handleOnNavSearch, navSearchColor, tags } = navConfig;

  const shouldRenderNav = renderAddPost || renderNavSearch || renderNavList;

  const tagsList = tags ? tags.split(',') : [];
  const isTagsNavbar = tagsList?.length > 1;

  return shouldRenderNav ? (
    <div className="nav" style={{ top: 5 }}>
      {renderAddPost && <div className="nav__add-post">{renderAddPost(addPostConfig)}</div>}
      <div className="nav__list">
        {renderNavList &&
          !isTagsNavbar &&
          renderNavList({
            socialFeeds,
            handleOnNavItemClick,
            navItemColor,
          })}
        {renderNavSearch &&
          !isTagsNavbar &&
          renderNavSearch({
            navSearchColor,
            handleOnNavSearch,
          })}
        {isTagsNavbar && <NavTagsList tags={tagsList} handleOnNavItemClick={handleOnNavItemClick} />}
      </div>
    </div>
  ) : null;
};

export default Nav;
